import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor() { }

  setItem(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string): T | null {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  addToList<T>(key: string, item: T): void {
    const existingList = localStorage.getItem(key);
    const list = existingList ? JSON.parse(existingList) : [];
    list.push(item);
    localStorage.setItem(key, JSON.stringify(list));
  }

  getList<T>(key: string): T[] {
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) : [];
  }

  clearList(key: string): void {
    localStorage.removeItem(key);
  }

  saveList(key: string, list: any[]): void {
    localStorage.setItem(key, JSON.stringify(list));
  }
}
